import React from "react"
import AllBikesCollection from "./AllBikesCollection"
import Typography from "../reusable/Typography/Typography"
import Button from "../reusable/components/Button"
import {useTranslation} from "next-i18next"

type BikesCollectionWrapperProps = {
    doneFetchingProducts: boolean;
    isLoadingMoreProducts: boolean;
    triggerFetchMore: () => void;
    filteredProducts: any[];
    unfilteredProducts: any[];
    filtersActive: boolean;
	searchActive: boolean;
    searchedProductsCount: number;
    filteredProductsCount: any;
    productsCount: number | undefined;
};

const BikesCollectionWrapper: React.FC<BikesCollectionWrapperProps> = ({
	doneFetchingProducts,
	isLoadingMoreProducts,
	triggerFetchMore,
	filteredProducts,
	unfilteredProducts,
	searchedProductsCount,
	searchActive,
	filtersActive,
	filteredProductsCount,
	productsCount
}) => {
	const {t} = useTranslation()
	return (
		<>
			<AllBikesCollection
				filteredBikes={filtersActive ? filteredProducts : unfilteredProducts}
				isLoadingMoreProducts={isLoadingMoreProducts}
				filtersLoading={isLoadingMoreProducts}
				bikesList={filteredProducts}
				filteredProductsLength={
					filtersActive ?
						filteredProductsCount! - 1 :
						searchActive ?
							searchedProductsCount :
                    productsCount! - 1
				}
			/>
			<div className="d-flex my-4 justify-content-center align-items-center">
				{doneFetchingProducts || (filtersActive && !filteredProducts?.length) ? null :
					<div className="d-flex align-items-center justify-content-start flex-column gap-2">
						{isLoadingMoreProducts ? null : <Typography className="text-black cursor-normal "
							variant="bodySm"
							style={{textDecoration: "underline", fontSize: "12px", lineHeight: "16px", fontWeight: 500}}>{t("showing-products-count-label").replace("x", (filtersActive ? filteredProducts?.length : searchActive ? searchedProductsCount : unfilteredProducts?.length)?.toString()).replace("y", (filtersActive ? filteredProductsCount : searchActive ? searchedProductsCount : productsCount)?.toString())}</Typography>}
						<Button disabled={isLoadingMoreProducts}
							fontSizeSmall
							isLoading={isLoadingMoreProducts}
							label={t("load-more-products")}
							bgColor="#ffbf4d"
							onClick={triggerFetchMore} /></div>}
			</div>
		</>
	)
}

export default BikesCollectionWrapper
